import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useEmployee } from '@/contexts/EmployeeContext'
import { useToast } from '@/hooks/use-toast'
import { KeyRound } from 'lucide-react'

const TestAccessCodeForm = () => {
  const [accessCode, setAccessCode] = useState('')
  const { verifyTestAccessCode } = useEmployee()
  const { toast } = useToast()
  const navigate = useNavigate()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    if (!accessCode.trim()) {
      toast({
        title: 'Giriş Kodu Gerekli',
        description: 'Lütfen sınav giriş kodunu girin.',
        variant: 'destructive',
      })
      return
    }

    const result = verifyTestAccessCode(accessCode.trim())

    if (result.valid) {
      toast({
        title: 'Erişim Onaylandı',
        description: 'Sınav erişiminiz onaylandı. Yönlendiriliyorsunuz.',
      })
      // Navigate to interview with the assignment ID
      navigate(`/interview?assignmentId=${result.assignmentId}`)
    } else {
      toast({
        title: 'Geçersiz Kod',
        description: 'Girdiğiniz giriş kodu geçerli değil. Lütfen kontrol edip tekrar deneyin.',
        variant: 'destructive',
      })
    }
  }

  return (
    <Card className="w-full max-w-md mx-auto shadow-md">
      <CardHeader className="text-center">
        <div className="mx-auto mb-4 bg-primary/10 p-3 rounded-full w-14 h-14 flex items-center justify-center">
          <KeyRound className="h-7 w-7 text-primary" />
        </div>
        <CardTitle>Sınav Erişimi</CardTitle>
        <CardDescription>Sınava başlamak için size verilen giriş kodunu girin</CardDescription>
      </CardHeader>
      <form onSubmit={handleSubmit}>
        <CardContent>
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="accessCode">Sınav Giriş Kodu</Label>
              <Input
                id="accessCode"
                placeholder="Örnek: ABC123"
                value={accessCode}
                onChange={(e) => setAccessCode(e.target.value.toUpperCase())}
                className="text-center text-lg tracking-wider uppercase"
                maxLength={6}
              />
            </div>
          </div>
        </CardContent>
        <CardFooter>
          <Button type="submit" className="w-full">
            Sınava Başla
          </Button>
        </CardFooter>
      </form>
    </Card>
  )
}

export default TestAccessCodeForm
